import script from "./EBook.vue?vue&type=script&setup=true&lang=js"
export * from "./EBook.vue?vue&type=script&setup=true&lang=js"

import "./EBook.vue?vue&type=style&index=0&id=7518e140&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7518e140"]])

export default __exports__